import React from 'react'
import PropTypes from 'prop-types'

import Color from 'constants/colors'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export const Item = styled.h4`
  height: 24px;
  padding: 6px 20px 0 20px;
  text-align: center;
  color: rgba(0,0,0,0.8);
  cursor: pointer;
  border-radius: 2px;

  @media screen and (max-width: 1023px) {
    width: 96px;
  }
  @media screen and (max-width: 767px) {
    width: auto;
    font-size: 12px;
    padding-right: 3px;
    padding-left: 3px;
    margin-left: 8px;
  }
  @media not all and (hover: none) {
    &:hover {
      color: white;
      background-color: ${Color('purple')};
      transition: background-color 150ms ease-out;
    }
  }
  &:active {
    background-color: ${Color('purple')};
	}
`;


const MenuItem = (props) => {
    const {to, text} = props;
    return(
      <NavLink to={to} style={{textDecoration:'none'}} activeClassName="activeHeaderNavLink">
        <Item>{text}</Item>
      </NavLink>
    )
}

MenuItem.propType = {
  text: PropTypes.string,
  to: PropTypes.string
}

export default MenuItem




// WEBPACK FOOTER //
// ./src/components/interactive/menu/menu-item.js